import {useParams} from '@github-ui/react-router'
import {createContext, use, useMemo} from 'react'

interface CurrentOrgRepoContextState {
  org: {
    login: string
  }
  repo?: {
    name: string
  }
}
const CurrentOrgRepoContext = createContext<CurrentOrgRepoContextState | null>(null)

export function CurrentOrgRepoProvider({children}: React.PropsWithChildren) {
  // Org is always defined. We provide a default value to make ts happy.
  const {org = '', repo} = useParams()

  const state = useMemo(() => ({org: {login: org}, repo: repo ? {name: repo} : undefined}), [org, repo])

  return <CurrentOrgRepoContext value={state}>{children}</CurrentOrgRepoContext>
}

export function useCurrentOrg() {
  const context = use(CurrentOrgRepoContext)

  if (!context) {
    throw new Error('useCurrentOrg must be used within CurrentOrgRepoProvider')
  }

  return context.org
}

export function useCurrentRepo() {
  const context = use(CurrentOrgRepoContext)

  if (!context) {
    throw new Error('useCurrentRepo must be used within CurrentOrgRepoProvider')
  }

  return context.repo
}
